export default __webpack_public_path__ + "static/poster-5c26456893ea2ca2191be7560d3b5f19.png";